import React, { useState, useEffect } from 'react';

import { Checkbox, MenuItem } from '@material-ui/core';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { singleTagTypeAutocompleteV1 } from 'services/search';

import { StyledFilterDisplay, ScrollableContainer, LastMenuItem } from '../styles';

const AutoCompleteFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon, tagType }) => {
  const [loading, setLoading] = useState(null);
  const [selected, setSelected] = useState({});
  const [data, setData] = useState(null);

  const getData = () => {
    setLoading(true);

    singleTagTypeAutocompleteV1({
      text: '',
      tagType,
      employeeIds: null,
    })
      .then((res) => {
        setData(
          res.length > 0
            ? res.map((pod) => ({
                value: `'${pod.displayName}'`,
                label: pod.displayName,
              }))
            : []
        );
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const makeCurrentStateEqualToSelectedState = () => {
    const selected = {};
    selectedFilters.forEach((id) => (selected[id] = true));
    setSelected(selected);
  };

  const handleSelect = (value) => {
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  };

  const handleApplyClick = () => {
    updateFilters(
      Object.keys(selected).filter((id) => selected[id]),
      filterName
    );
    document.body.click();
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <CustomMenu
      icon={
        <StyledFilterDisplay
          width="20%"
          icon={icon}
          name={filterName}
          selectedCount={selectedFilters.length}
          noLeftBorder={noLeftBorder}
          active={selectedFilters.length > 0}
          disabled={loading}
          removeFilters={removeFilters}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
    >
      <StyledDropdownList>
        <ScrollableContainer>
          {data &&
            data.map((entry, index) => (
              <MenuItem onClick={() => handleSelect(entry.value)} value={entry.value}>
                <Checkbox checked={Boolean(selected[entry.value])} color="primary" />
                <StyledTypography display="inline" variant="body2">
                  {entry.label}
                </StyledTypography>
              </MenuItem>
            ))}
        </ScrollableContainer>
        <LastMenuItem onClick={handleApplyClick}>
          <StyledTypography color="primary" variant="body2">
            Apply
          </StyledTypography>
        </LastMenuItem>
      </StyledDropdownList>
    </CustomMenu>
  );
};

const StyledDropdownList = styled(DropdownList)`
  li {
    padding-left: 5px;
    span.MuiButtonBase-root {
      padding: 4px 10px;
    }
  }
`;

export default AutoCompleteFilter;
